import {TouchableWithoutFeedback} from "react-native-gesture-handler";
import {View} from "react-native";
import * as React from "react";

export const DotSlider = ({currentIndex, index, changePane}) => {
    return <TouchableWithoutFeedback onPress={() => changePane(index)}>
        <View style={{width: 30, height: 30, alignItems: 'center', justifyContent: 'center'}}>
            <View style={[
                {width: 10, height: 10, borderRadius: 10},
                currentIndex >= index ? {backgroundColor: 'white'} : {borderColor: 'white', borderWidth: 1}
            ]}></View>
        </View>
    </TouchableWithoutFeedback>
}